import i18n from "../i18n/config";
import { DifficultyLevel } from "../types/api";

export const getLocalizedField = <
  T extends {
    name?: string;
    name_ar?: string;
    title?: string;
    title_ar?: string;
    subtitle?: string;
    subtitle_ar?: string;
  }
>(
  item: T,
  field: "name" | "name_ar" | "title" | "subtitle" = "name"
): string => {
  const lang = i18n.language || "ar";

  // Auto-detect Content type: if field is 'name' (default) but item has 'title' property, use 'title' instead
  let actualField = field;
  if (field === "name" && "title" in item && item.title !== undefined) {
    actualField = "title";
  }

  // Handle Content type (has title/title_ar or subtitle/subtitle_ar)
  if (actualField === "title" || actualField === "subtitle") {
    const arField = `${actualField}_ar` as keyof T;
    const enField = actualField as keyof T;
    if (lang === "ar" && arField in item && item[arField]) {
      return String(item[arField]);
    }
    return String(item[enField] || "");
  }

  // Handle other types (has name/name_ar)
  if (lang === "ar" && "name_ar" in item && item.name_ar) {
    return item.name_ar;
  }
  return item.name || "";
};

export const getLocalizedText = (
  item: {
    [key: string]: any;
  },
  field: string
): string => {
  const lang = i18n.language || "ar";
  const arField = `${field}_ar`;
  if (lang === "ar" && item[arField]) {
    return item[arField];
  }
  return item[field] || "";
};

export const getDifficultyName = (
  difficulty: DifficultyLevel | undefined
): string => {
  if (!difficulty) return "";
  const lang = i18n.language || "ar";
  return lang === "ar" ? difficulty.name_ar : difficulty.name;
};

export const getDifficultyPoints = (
  difficulty: DifficultyLevel | undefined
): number => {
  if (!difficulty) return 0;
  return difficulty.value;
};

export const formatPrice = (amount: string): string => {
  return `${amount} KWD`;
};
